export default function TransitionBlock2() {
	return (
		<div className="relative">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1440 320"
				className="w-full h-24"
				preserveAspectRatio="none"
			>
				{/* Fondo gris arriba */}
				<path
					fill="#f9fafb" // gris claro bg-gray-50
					d="M0,0L1440,80L1440,0L0,0Z"
				></path>
				{/* Blanco abajo */}
				<path fill="#ffffff" d="M0,80L1440,160L1440,320L0,320Z"></path>
			</svg>
		</div>
	);
}
